import { mutationOptions, queryOptions } from '@tanstack/react-query';
import {
  deleteHardwareVersionAPI,
  listHardwareVersionsAPI,
  loadHardwareVersionByIdAPI,
  saveHardwareVersionAPI,
} from '@/service';
import { queryClient } from '@/configuration';
import { createQueryKeys } from '@util/querykey.util';

const hardwareVersionKeys = createQueryKeys('hardwareVersion');

export const listHardwareVersionsQueryOptions = queryOptions({
  queryKey: hardwareVersionKeys.list,
  queryFn: listHardwareVersionsAPI,
  initialData: [],
});

export const loadHardwareVersionByIdQueryOptions = (id: number | undefined) =>
  queryOptions({
    queryKey: hardwareVersionKeys.byId(id),
    queryFn: () => loadHardwareVersionByIdAPI(id),
    enabled: !!id,
  });

export const saveHardwareVersionMutationOptions = mutationOptions({
  mutationFn: saveHardwareVersionAPI,
  onSuccess: () => queryClient.invalidateQueries(listHardwareVersionsQueryOptions),
});

export const deleteHardwareVersionMutationOptions = mutationOptions({
  mutationFn: deleteHardwareVersionAPI,
  onSuccess: () => queryClient.invalidateQueries(listHardwareVersionsQueryOptions),
});
